import { getOverlayAlpha, alpha } from '@mui/material';
import type { Theme } from '@mui/material';

export function darkModeBackgroundImageElevation(theme: Theme, elevation = 1) {
    return theme.palette.mode === 'dark'
        ? `linear-gradient(${alpha(
              '#fff',
              parseFloat(getOverlayAlpha(elevation)),
          )}, ${alpha('#fff', parseFloat(getOverlayAlpha(elevation)))})`
        : undefined;
}
